export default {
    TRANSFERENCIA_DEFINITIVA: 'Transferência Definitiva',
    DOACAO_ENTRE_ORGAOS: 'Doação entre Órgãos',
    BAIXA: 'Baixa'
}
